import React, { useState } from 'react';
import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import ReversalListsModal from '../components/ReversalListsModal';
interface ReversalListsProps {
  onLogout: () => void;
}
const ReversalLists: React.FC<ReversalListsProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-5000">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Reversal Lists" data-id="element-5001" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="reversal-lists" data-id="element-5002" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: 0
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-5003">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-5004">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-5005">
            <Icon icon="lucide:undo-2" width={28} height={28} color="#8B5CF6" data-id="element-5006" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-5007">
              Reversal Upload History
            </Typography>
          </Box>
          <ReversalListsModal data-id="element-5008" />
        </Box>
      </Box>
    </Box>;
};
export default ReversalLists;